export enum WishType {
  Company = 'Rewards::Product',
  Retailer = 'Rewards::NGC::Product',
}
